// Canonical owner-selectable Open Library sections. The ALL filter is not a destination.
export const OPEN_LIBRARY_SECTION_OPTIONS = Object.freeze([
  { id: "RECIPES", title: "Рецепты" },
  { id: "QUESTIONS", title: "Ответы на ваши вопросы" },
  { id: "TECHNOLOGY", title: "Технологии" },
  { id: "TROUBLESHOOTING", title: "Ошибки и решения" },
  { id: "INGREDIENTS", title: "Ингредиенты" },
  { id: "HISTORY", title: "Истории и традиции" },
]);

export const isOpenLibrarySection = (id) =>
  OPEN_LIBRARY_SECTION_OPTIONS.some((item) => item.id === id);
